<ejs-dropdownlist
  #list
  [dataSource]="rows"
  [fields]="fields"
  [allowFiltering]="true"
  [filterBarPlaceholder]="'TankSetup.UserGroupPicker.Search' | translate"
  [placeholder]="placeholder | translate"
  [enabled]="enabled"
  [popupWidth]="'640px'"
  [noRecordsTemplate]="(loading ? 'TankSetup.UserGroupPicker.Loading' : 'TankSetup.UserGroupPicker.NoRecords') | translate"
  cssClass="e-outline tl-templated-ddl user-group-search-select"
  (open)="onOpen()"
  (filtering)="onFiltering($event)"
  (change)="onChange($event)"
>
  <ng-template #headerTemplate>
    <div class="ugss-row ugss-header">
      <span>{{ 'TankSetup.UserGroupPicker.Name' | translate }}</span>
      <span>{{ 'TankSetup.UserGroupPicker.Email' | translate }}</span>
      <span>{{ 'TankSetup.UserGroupPicker.OrganizationName' | translate }}</span>
      <span>{{ 'TankSetup.UserGroupPicker.Source' | translate }}</span>
    </div>
  </ng-template>
  <ng-template #itemTemplate let-data>
    <div class="ugss-row">
      <span [title]="data.name">{{ data.name }}</span>
      <span [title]="data.emailAddress">{{ data.emailAddress }}</span>
      <span [title]="data.organizationName">{{ data.organizationName }}</span>
      <span>{{ ('TankSetup.UserGroupPicker.' + data.source) | translate }}</span>
    </div>
  </ng-template>
</ejs-dropdownlist>
<div *ngIf="loading" class="ugss-loading">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
